import React, { useEffect, useState } from 'react';
import { LoadingIndicator, Text } from 'library';
import { PastWorkerDTO, getPastWorkers } from './preferredWorkersApi';
import MultiSelectDropDown from 'reusableComponents/multipleDropdown';
import { ProviderSelection } from 'parent-portal/forms/JobRequestTypes';
import { styled } from '@mui/material';

interface Props {
    selected: ProviderSelection[];
    onChange: (selectedProviderUserIds: ProviderSelection[]) => void;
}

export default function PastWorkersInput({ selected, onChange }: Props) {
    const [pastWorkers, setPastWorkers] = useState<PastWorkerDTO[]>([]);
    const [loading, setLoading] = useState(false);

    const pastWorkerOptions = pastWorkers.map((worker) => ({
        id: worker.id,
        name: `${worker.first_name} ${worker.last_name}`,
    }));

    useEffect(() => {
        setLoading(true);
        getPastWorkers()
            .then(setPastWorkers)
            .finally(() => setLoading(false));
    }, []);

    const onDropdownSelect = (event: { target: { value: number[] } }) => {
        onChange(pastWorkerOptions.filter((it) => event.target.value.includes(it.id)));
    };

    const renderContent = () => {
        if (loading) {
            return <LoadingIndicator />;
        }
        if (pastWorkers.length === 0) {
            return <Text>It looks like you have not set any preferred workers.</Text>;
        }
        return (
            <MultiSelectDropDown
                helperText="Select workers to recommend for this job."
                selected={selected.map((it) => it.id)}
                fields={pastWorkerOptions}
                onChange={onDropdownSelect}
            />
        );
    };

    return (
        <>
            <Spacer />
            <Text variant="h2" bold>
                Past Workers
            </Text>
            {renderContent()}
        </>
    );
}

const Spacer = styled('div')({
    marginTop: 15,
});
